module.exports = __webpack_public_path__ + "static/media/publish-simultaneous-desktop-es.7c326e1f.png";